import { render, staticRenderFns } from "./custom-radio.vue?vue&type=template&id=53c036b0&scoped=true&"
import script from "./custom-radio.vue?vue&type=script&lang=js&"
export * from "./custom-radio.vue?vue&type=script&lang=js&"
import style0 from "./custom-radio.sass?vue&type=style&index=0&id=53c036b0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c036b0",
  null
  
)

export default component.exports